
import template from './report_definition_dialog.html';

class ReportDefinitionDialogViewModel
{
	constructor (page)
	{
		this.page = page;
		this.dialog_title = ko.observable('');
		this.action = ko.observable('');

		this.report_definition_id = ko.observable('');
		this.report_definition = ko.observable();
		this.version = ko.observable('');

		this.query_text = ko.observable('');
		this.form_scope_id = ko.observable('');
		this.description = ko.observable('');
		this.group = ko.observable('');
		this.name = ko.observable('');
		this.form_scope_list = ko.observableArray([]);
		this.available_types = ko.observableArray(['Function', 'Query']);
		this.selected_type = ko.observableArray(['Function']);
		this.query_sql = ko.observable('');
		this.available_schemas = ko.observableArray([]);
		this.available_functions = ko.observableArray([]);
		this.selected_function = ko.observable('');
		this.raw_function_data = ko.observableArray([]);
		this.raw_table_data = ko.observableArray([]);
		this.selected_schema = ko.observable('');
		this.available_tables = ko.observableArray([]);
		this.selected_table = ko.observable('');
		this.available_columns = ko.observableArray([]);
		this.numeric_columns = ko.observableArray([]);
		this.selected_columns = ko.observableArray([]);


		this.selected_columns.subscribe(function() {this.determine_group_by()},this);
		
		this.def_agg_columns = ko.observable();
		this.agg_columns = ko.observableArray([{ 
			func: ko.observable(''), 
			field: ko.observable(''),
			alias: ko.observable('')
		}]);
		this.def_agg_columns.subscribe(option => {
			if (option && (this.agg_columns().length === 0 || this.agg_columns() === ''))
				this.agg_columns.push({ func: ko.observable(''), field: ko.observable(''), alias: ko.observable('')});
			}
		);

		this.def_filter = ko.observable();
		this.available_filter_join_options = ko.observableArray(['AND', 'OR']);
		this.selected_filter_join_option = ko.observable('');

		this.filters = ko.observableArray([{ 
			field: ko.observable(''), 
			operator: ko.observable(''), 
			value: ko.observable('') 
		}]);

		this.selected_filter_join_option.subscribe(option => {
			if (option && (this.filters().length === 0 || this.filters() === ''))
				this.filters.push({ field: ko.observable(''), operator: ko.observable(''), value: ko.observable('') });
		});

		this.require_group_by = ko.observable(false);
		this.group_by_columns = ko.observableArray([]);
		this.order_by = ko.observable();
		this.order_by_fields = ko.observableArray([{ 
			field: ko.observable(''), 
			sortorder: ko.observable('ASC') 
		}]);
		this.order_by.subscribe(option => {
			if (option && (this.order_by_fields().length === 0 || this.order_by_fields() === ''))
				this.order_by_fields.push({ field: ko.observable(''), sortorder: ko.observable('ASC') });
			}
		);

		this.sortfield = ko.observable('');
		this.sortorder = ko.observable('');
		this.available_groups = ko.observableArray([]);
		this.settings = ko.observable();
		
		

		this.selected_type.subscribe(type => {
			if (type)
				this.selected_schema('');
		});

		this.selected_schema.subscribe(schema => {
			if (schema && this.selected_type() === 'Function')
			{
				let functions = this.raw_function_data().filter(item => item.routine_schema === schema).map(item => item.routine_name);
				this.available_functions(functions);
			}
			else if (schema && this.selected_type() === 'Query')
			{
				let tables = this.raw_table_data().filter(item => item.schema === schema).map(item => item.name);
				// Extract unique table names
				let unique_tables = [...new Set(tables.map(item => item))];
				this.available_tables(unique_tables);
			}
		});

		this.selected_table.subscribe(table => {
			if (table && this.selected_schema != '' && this.selected_type() === 'Query')
			{
				this.get_all_columns()
			}
		});

		this.def_query_ui_fields = ko.observable(false);
		this.query_ui_fields = ko.observableArray([]);
		this.def_query_ui_fields.subscribe(sub_yn => {
			if (sub_yn && this.query_ui_fields().length == 0){
				this.add_query_ui_field('', '', 'text', '', '=', '');
			}
		});


		this.title = ko.computed(() => {
			return this.dialog_title();
		}, this);

		this.ui_fields = ko.observableArray([{
			label: ko.observable(''), 
			name: ko.observable(''), 
			type: ko.observable(''),
			default_value: ko.observable('')
		}]);
	}

	async load_definition(){
		if (this.report_definition_id() == '')
			return;

		let request_obj = {
			schema: 'reports',
			table: 'report_definition',
			filter_join: 'AND',
			filter: [
				{ field: 'report_definition_id', operand: '=', value: this.report_definition_id()},
				{ field: 'version', operand: '=', value: this.version()}
			],
			limit: 1
		};
		let response = await Grape.fetches.getJSON('/api/record', request_obj);
		if (response.status !== 'OK') {
			console.error('Report definition not found:', this.report_definition_id());
			return;
		}
		this.report_definition(response.records[0]);

		this.name(this.report_definition().name);
		this.description(this.report_definition().description);
		this.group(this.report_definition().group);
		this.selected_type(this.report_definition().report_type === 'query' ? 'Query' : 'Function');
		this.selected_schema(this.report_definition().default_function_criteria.selected_schema);
		this.selected_table(this.report_definition().default_function_criteria.selected_table);

		await this.get_all_columns();

		if (this.report_definition().report_type = 'query'){
			this.selected_columns(this.report_definition().default_function_criteria.selected_columns || []);	
			if (this.report_definition().default_function_criteria.aggregate_columns && this.report_definition().default_function_criteria.aggregate_columns.length > 0){
				this.agg_columns(this.report_definition().default_function_criteria.aggregate_columns);
				this.group_by_columns(this.report_definition().default_function_criteria.group_by);
				this.def_agg_columns(true);
				this.require_group_by(true);
			}
			this.def_filter(this.report_definition().default_function_criteria.use_filter == 'YES' ? true : false);
			this.selected_filter_join_option(this.report_definition().default_function_criteria.filter_join || '');
			this.filters(this.report_definition().default_function_criteria.filter || []);
			
			// Query UI fields
			this.query_ui_fields([]);
			let q_ui_fields = this.report_definition().default_function_criteria.query_ui_fields || [];
			for (let field of q_ui_fields){
				this.add_query_ui_field(field.label, field.name, field.type, field.list_options,	field.operator, field.default_value);
			}
			this.def_query_ui_fields(this.report_definition().default_function_criteria.def_query_ui_fields == 'YES' ? true : false);

			if (this.report_definition().sort_fields && this.report_definition().sort_fields.length > 0){
				this.order_by(true);
				this.order_by_fields([]);
				for (let field of report_definition.sort_fields){
					this.order_by_fields.push({field: field.field, sortorder: field.sortorder});
				}
			}
			//this.sortfield(this.report_definition().default_function_criteria.sortfield || '');
			//this.sortorder(this.report_definition().default_function_criteria.sortorder || '');
			// backwards compatibility
			if (this.report_definition().default_function_criteria.sortfield && this.report_definition().default_function_criteria.sortfield != ''){
				this.order_by_fields.push(
					{field: this.report_definition().default_function_criteria.sortfield,
					sortorder: this.report_definition().default_function_criteria.sortorder});
			}
		}
	}

	async get_all_columns ()
	{
		let response = await Grape.fetches.getJSON('/api/record', {
			schema: 'grape',
			table: 'v_pg_columns',
			limit: 5000,
			filter: [
				{field: 'schema_name', 'operator': '=', value: this.selected_schema()},
				{field: 'table_name', 'operator': '=', value: this.selected_table()}
			]
		});
		if (response.status === 'OK'){
			this.available_columns(response.records.map(item => item.column_name));
			this.numeric_columns(response.records.filter(item => item.datatype == 'numeric').map(item => item.column_name));
		}
		else
			console.error(response);
	}

	determine_group_by(){
		let require_group_by = false;
		let group_by_func = ['SUM','AVG'];
		let group_by_func_columns = [];
		for (let agg_field of this.agg_columns()){
			if (group_by_func.indexOf(agg_field.func) > -1){
				require_group_by = true;
				group_by_func_columns.push(agg_field.field);
			}
		}
		this.require_group_by(require_group_by);
		this.def_agg_columns(require_group_by);

		let gbc = [];
		if (require_group_by){
			for (let column of this.selected_columns()){
				if (group_by_func_columns.indexOf(column) == -1){
					gbc.push(column)
				}
			}
		}
		this.group_by_columns(gbc);
	}

	moveUp(index){
		if (index <= 0)
		 	return;
		let tmp_arr = {...this.group_by_columns()};
		this.group_by_columns.splice(index-1, 2, tmp_arr[index], tmp_arr[index-1]);
	}

	moveDown(index){
		if (index >= this.group_by_columns().length-1)
			return;
	   let tmp_arr = {...this.group_by_columns()};
	   this.group_by_columns.splice(index, 2, tmp_arr[index+1], tmp_arr[index]);
	}


	btn_add_own_column_row_click ()
	{
		this.agg_columns.push({ 
			func: ko.observable(''), 
			field: ko.observable(''),
			alias: ko.observable('')
		});
		this.determine_group_by();
	}

	btn_remove_own_column_row_click (index)
	{
		if (this.agg_columns().length > 0)
			this.agg_columns.splice(index, 1);
		this.determine_group_by();
	}

	btn_add_sort_row_click ()
	{
		this.order_by_fields.push({ 
			field: ko.observable(''), 
			sortorder: ko.observable('ASC')
		});
	}

	btn_remove_sort_row_click (index)
	{
		if (this.order_by_fields().length > 0)
			this.order_by_fields.splice(index, 1);
		if (this.order_by_fields().length == 0)
			this.order_by(false);
	}

	btn_add_filter_row_click ()
	{
		this.filters.push({ 
			field: ko.observable(''), 
			operator: ko.observable(''), 
			value: ko.observable('')
		});
	}

	btn_remove_filter_row_click (index)
	{
		if (this.filters().length > 0)
			this.filters.splice(index, 1);
		if (this.filters().length == 0)
			this.def_filter(false);
	}

	btn_add_ui_field_row_click ()
	{
		this.ui_fields.push({ 
			label: ko.observable(''), 
			name: ko.observable(''), 
			type: ko.observable(''),
			default_value: ko.observable('')
		});
	}

	btn_remove_ui_field_row_click (index)
	{
		if (this.ui_fields().length > 1)
			this.ui_fields.splice(index, 1);
	}

	btn_close_click ()
	{
		this.page.close(false);
	}

	async btn_save_click ()
	{
		if (this.name() === '')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No Name provided'});
			return;
		}
		else if (typeof this.selected_schema() === 'undefined')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No schema selected'});
			return;
		}
		else if (typeof this.selected_function() === 'undefined' && this.selected_type() === 'Function')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No function selected'});
			return;
		}
		else if (typeof this.selected_table() === 'undefined' && this.selected_type() === 'Query')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No table/view selected'});
			return;
		}
		else if (this.selected_columns().length === 0 && this.selected_type() === 'Query')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No columns selected'});
			return;
		}
/*
		else if (typeof this.sortfield() === 'undefined' && this.selected_type() === 'Query')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No sortfield selected'});
			return;
		}
*/
		let select_fields = this.selected_columns();
		let agg_def = [];

		if (this.require_group_by()){
			agg_def = ko.toJS(this.agg_columns()).map(item => ({
				func: item.func,
				field: item.field,
				alias: item.alias
			})).filter( (obj) => obj.field?obj.field != '' : false) 
			;
			for (let agg of agg_def){
				if (select_fields.indexOf(agg.field) > -1){
					select_fields.splice(select_fields.indexOf(agg.field),1);
				}
			}
		}

		let unwrap_filters = ko.toJS(this.filters()).map(filter => ({
			field: filter.field,
			operator: filter.operator,
			value: filter.value
		}));

		let sort_fields = [];
		if (this.order_by()){
			sort_fields = ko.toJS(this.order_by_fields()).map(order_field => ({
				field: order_field.field,
				sortorder: order_field.sortorder
			}));
		}

		let ui_fields = ko.toJS(this.ui_fields());
		let unwrap_ui_fields = [];
		let default_values = {};
		if (Object.keys(ui_fields).length > 0)
		{
			unwrap_ui_fields = ui_fields.map(field => ({
				name: field.name,
				type: field.type,
				label: field.label
			}));

			for (const field of ui_fields ){
				if (field.type == 'json'){
					Object.assign(default_values, { [`${field.name}`] : JSON.parse(field.default_value) });
				}else{
					Object.assign(default_values, { [`${field.name}`] : field.default_value });
				}
			}	
		}

		let default_function_criteria , definition;
		if (this.selected_type() == 'Query'){
			default_function_criteria = {
				'selected_schema': this.selected_schema(),
				'selected_table': this.selected_table(),
				'selected_columns': select_fields,
				'aggregate_columns': agg_def,
				'group_by': this.group_by_columns(),
				'use_filter': this.def_filter() ? 'YES' : 'NO',
				'filter_join': this.def_filter() ? this.selected_filter_join_option() : '',
				'filter': this.def_filter() ? unwrap_filters : '',
				'group_by': this.group_by_columns(),
				'sortfield': this.sortfield(),
				'sortorder': this.sortorder(),
				'sort_fields': sort_fields
			};
		}
		if (this.selected_type() == 'Function'){
			default_function_criteria = default_values;
			definition = {
				'function_schema': this.selected_schema(),
				'function_name': this.selected_function()
			}
		}

		let params = {
			'report_definition_id': this.report_definition_id(),
			'version': null,
			'active' : this.report_definition().active,
			'name': this.name(),
			'description': this.description(),
			'group': this.group(),
			'report_type': this.selected_type(),
			'definition': definition,
			'ui_fields': unwrap_ui_fields,
			'default_function_criteria': default_function_criteria
		};

		let data = await Grape.fetches.postJSON('/api/report/definition', params);
		if (data.status === 'OK')
			this.page.close(data);
	}
}

class ReportDefinitionDialog
{
	constructor (bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ReportDefinitionDialogViewModel(this);
		this.name = 'ReportDefinitionDialog';
		this.title = ko.observable('');
	}

	async init ()
	{
		if (this.bindings.initial_values){
			this.viewModel.report_definition_id(this.bindings.initial_values.report_definition_id);
			this.viewModel.version(this.bindings.initial_values.version);
		}
		
		let settings_result = await Grape.fetches.getJSON('/api/setting/reports.exposed_schemas');
		this.viewModel.settings(settings_result.value);

		let exposed_schemas = []
		if (settings_result.value && settings_result.value != '')
			exposed_schemas = settings_result.value.split(',');
		else 
			exposed_schemas.push('reports');

		let filter = exposed_schemas.map((item) => { return {'field': 'routine_schema', 'operator': '=', 'value': item} });

		let body = {
			schema: 'grape',
			table: 'v_pg_functions',
			filter: filter,
			filter_join: 'OR',
			limit: 5000
		};
		let data = await Grape.fetches.getJSON('/api/record', body);
		if (data.status === 'OK'){
			this.viewModel.raw_function_data(data.records);
			// Extract unique schemas
			let unique_schemas = [...new Set(data.records.map(item => item.routine_schema))];
			this.viewModel.available_schemas(unique_schemas);
		}
		await this.get_all_tables();

		// Get all groups
		let available_groups = [];
		let result = await Grape.fetches.getJSON('/api/report/definition/groups');
		if (result.status !== 'ERROR')
		{
			if (result.records && (result.records != null)){
				result.records.forEach((record) => {
					if(available_groups.indexOf(record.group) == -1)
						available_groups.push(record.group);
				});
			}
			this.viewModel.available_groups(available_groups);
		}else{
			Grape.alert_api_error(result);
		}

		if (this.viewModel.report_definition_id() > 0)
			this.viewModel.action('create');
		else
			this.viewModel.action('edit');

		this.viewModel.load_definition();

		// ToDo Why is this done ???
		//this.get_scope_form_data(this.viewModel.action(), this.title());
		//Get all tables for schema
		
	}

	async get_scope_form_data (action, title)
	{
		if (!title)
			if (action === 'create')
				this.title('Add Report Definition');
			else
				this.title('Edit Report Definition');

		let scope_params = {
			schema: 'gf',
			table: 'scope',
			sortfield: 'scope_id',
			limit: 5000
		}

		let data = await Grape.fetches.getJSON('/api/record', scope_params);
		if (data.status === 'OK')
		{
			if (data.result_count > 0)
			{
				data.records.forEach((record) => {
					this.form_scope_list().push({'value': record.scope_id, 'text': record.name});
				});
			}
		}
	}

	async get_all_tables ()
	{
		// Get all the tables and views as options based on selected schema
		let exposed_schemas = this.viewModel.available_schemas();
		let filter = exposed_schemas.map((item) => { return {'field': 'schema', 'operator': '=', 'value': item} });

		let response = await Grape.fetches.getJSON('/api/record', {
			schema: 'grape',
			table: 'v_pg_tables',
			limit: 5000,
			fields: ['name', 'schema'],
			filter: filter,
			filter_join: 'OR'
		});
		if (response.status === 'OK')
			this.viewModel.raw_table_data(response.records);
		else
			console.error(response);
	}
}

export default {
	name: 'ReportDefinition',
	dialog_class: ReportDefinitionDialog,
	template: template,
	provider: "ps"
};
